import React, { ReactNode } from 'react';

interface PageLayoutProps {
  title: string;
  children: ReactNode;
}

/**
 * PageLayout Component
 *
 * Provides a consistent layout structure for pages, including a title and content area.
 */
const PageLayout: React.FC<PageLayoutProps> = ({ title, children }) => {
  return (
    <div className="container mx-auto px-4 py-8"> {/* Basic container and padding */}
      <h1 className="text-3xl font-bold mb-6">{title}</h1> {/* Page title */}
      <main>
        {children} {/* Page content */}
      </main>
    </div>
  );
};

export default PageLayout; 